export default {
    SomethingWentWrong: 'Something went wrong. Please try again.',
    InternalServerError: 'Internal server error.',
    InternetConnectionError: 'Please check your internet connection or try again later.',
    NoRecordsFound: 'No records found.',
    NoDataRecorded: 'No data recorded',
    NoAssociatedFacilities: 'No associated facilities found.',
    NetworkError: 'Network error.',
    ForbiddenError: `You don't have permission to access this page or resource.`,
    SetDefaultPatientPharmacy: "Patient's pharmacy set as default successfully.",
    SetUpdateMyProfile: 'Profile updated successfully.',
    DeleteVitalContent: 'Do you want to delete this vital?',
    DeleteInjectionContent: 'Do you want to delete this injection?',
    DeleteInsuranceContent: 'Do you want to delete this insurance?',
    DeleteImmunizationContent: 'Do you want to delete this immunization?',
    DeleteDiagnosisContent: 'Do you want to delete this problem?',
    DeleteAllergiesContent: 'Do you want to delete this allergy?',
    DeletePharmacyContent: 'Do you want to delete this pharmacy?',
    DeleteMedicineContent: 'Do you want to delete this medication?',
    DeleteProcedureContent: 'Do you want to delete this procedure?',
    PrescriptionSignedSuccess: 'Prescription has been signed successfully.',
    DeleteLabOrderResultContent: 'Do you want to delete this lab result?',
    DeleteImageResultContent: 'Do you want to delete this radiology result?',
    DeleteImageOrderContent: 'Do you want to delete this radiology order?',
    DeleteLabOrderContent: 'Do you want to delete this lab order?',
    DeleteTaskContent: 'Do you want to delete this task?',
    DeletePatientReminderContent: 'Do you want to delete this reminder?',
    DeleteKYCContent: 'Do you want to delete this ID?',
    DeleteCareGiverContent: 'Do you want to delete this caregiver?',
    DeleteGuarantorContent: 'Do you want to delete this guarantor?',
    AppointmentCancelledSuccess: 'Appointment cancelled successfully.',
    ConfirmPrimaryCareProvider: 'Do you want to set this care provider as primary?',
    ConfirmDefaultPharmacy: 'Do you want to set this pharmacy as the default pharmacy?',
    ConfirmAddPharmacy: 'Do you want to add this pharmacy?',
    DeleteDocumentContent: 'Do you want to delete this document?',
    DeleteReferralContent: 'Do you want to delete this referral?',
    DeleteMessageContent: 'Do you want to delete this message?',
    TrashMessageContent: 'Do you want to move this message to trash?',
    CancelAppointment: 'Do you want to cancel this appointment?',
    ConfirmAppointment: 'Do you want to confirm this appointment?',
    QuestionnaireSaveSuccess: 'Questionnaire saved successfully.',
    DeleteUrgentCare: 'Do you want to delete this urgent care record?',
    CancelUrgentCare: 'Once cancelled, you cannot edit this urgent care. Do you want to continue anyway?',
    CompleteUrgentCare: 'Do you want to complete this urgent care?',
    QuestionnaireSubmitSuccess: 'Questionnaire submitted successfully.',
    PatientSettingSuccess: 'Setting details saved successfully.',
    CareGiverSaveSuccess: 'Caregiver saved successfully.',
    CareGiverDeleteSuccess: 'Caregiver deleted successfully.',
    PatientIdSaveSuccess: 'ID saved successfully.',
    PatientDetailsSaveSuccess: 'Profile details saved successfully.',
    PatientIdDeleteSuccess: 'ID deleted successfully.',
    GuarantorSuccess: 'Guarantor saved successfully.',
    FacilitySaveSuccess: 'Facility saved successfully.',
    FacilityUpdatedSuccess: 'Facility updated successfully.',
    AdditionalRefillRequest: 'Do you want to send a refill request for this prescription?',
    SuccessAdditionalRefillRequest: 'Request for additional refill sent successfully.',
    SetPrimaryPatientInsurance: "Patient's insurance set as primary successfully.",
    ConfirmDefaultInsurance: 'Do you want to set this insurance as the primary insurance?',
    DeleteNotification: 'Do you want to delete this notification?',
    VideoSessionExpired: 'Video session has expired or completed. Please contact Admin for further assistance.',
    ProviderNotavailableWarn: 'Please wait for a while. The provider will join you soon.',
    ProviderAvailableWarn: 'The provider is available for the video session. Please join the call.',
    ProviderRunningLateWarn: 'The provider is running a bit late. Please wait for a while they will join you soon.',
    NotificationReadSuccess: 'Notifications marked as read successfully.',
    AppointmentSaveSuccess: 'Appointment saved successfully.',
    AppointmentComfirmSuccess: 'Appointment confirmed successfully.',
    AppointmentDateError: 'Please select a future date/time for the appointment.',
    InsuranceSaveSuccess: 'Insurance saved successfully.',
    InsuranceSDeleteSuccess: 'Insurance deleted successfully.',
    PharmacySaveSuccess: 'Pharmacy saved successfully.',
    PharmacyDeleteSuccess: 'Pharmacy deleted successfully.',
    ProblemDeleteSuccess: 'Problem deleted successfully.',
    ProblemSaveSuccess: 'Problem saved successfully.',
    MedicineDeleteSuccess: 'Medicine deleted successfully.',
    MedicineSaveSuccess: 'Medicine saved successfully.',
    UrgentCareSaveSuccess: 'Urgent care saved successfully.',
    UrgentCareDeleteSuccess: 'Urgent care deleted successfully.',
    UrgentCareMarkAsCompleteSuccess: 'Urgent care marked as completed successfully.',
    UrgentCareMarkAsCancelSuccess: 'Urgent care marked as cancelled successfully.',
    MessageSaveSuccess: 'Message saved successfully.',
    MessageDeleteSuccess: 'Message deleted successfully.',
    MessagesMarkAsReadSuccess: 'Messages marked as read successfully.',
    MessagesMarkAsUnReadSuccess: 'Messages marked as unread successfully.',
    LabResultSaveSuccess: 'Lab result saved successfully.',
    LabResultDeleteSuccess: 'Lab result deleted successfully.',
    LabResultSignSuccess: 'Lab result signed successfully.',
    LabOrderSaveSuccess: 'Lab order saved successfully.',
    ImageResultSaveSuccess: 'Radiology result saved successfully.',
    ImageResultDeleteSuccess: 'Radiology result deleted successfully.',
    ImageResultSignSuccess: 'Radiology result signed successfully.',
    ImageOrderLinkSuccess: 'Radiology order linked successfully.',
    ImageOrderDeleteSuccess: 'Radiology order deleted successfully.',
    ProcedureDeleteSuccess: 'Procedure deleted successfully.',
    ProcedureSaveSuccess: 'Procedure saved successfully.',
    AllergyDeleteSuccess: 'Allergy deleted successfully.',
    AllergySaveSuccess: 'Allergy saved successfully.',
    VitalDeleteSuccess: 'Vital deleted successfully.',
    VitalSaveSuccess: 'Vital saved successfully.',
    ImmunizationDeleteSuccess: 'Immunization deleted successfully.',
    ImmunizationSaveSuccess: 'Immunization saved successfully.',
    DietDeleteSuccess: 'Diet deleted successfully.',
    DietSaveSuccess: 'Diet saved successfully.',
    DeleteDietContent: 'Do you want to delete this diet?',
    DocumentAddSuccess: 'Patient document saved successfully.',
    DocumentDeleteSuccess: 'Patient document deleted successfully.',
    NotificationDeleteSuccess: 'Notifications deleted successfully.',
    PatientSaveSuccess: 'Patient saved successfully.',
    ProviderRejectJoiningRequest: 'Your joining request has been declined. Please try to rejoin later.',
    askDeviceMessage: 'To join the video room, your browser will request access to your camera and microphone.',
    deniedDeviceMessage: 'It seems your browser is blocked from accessing your camera and/or microphone.',
    EmailOtpSendSuccess: 'OTP sent to your email address successfully.',
    ProfileCompleteSuccess: 'Profile details completed successfully.',
    BlurBackgroungNotSupport: 'Blur background is not supported on your device.',
    InsuranceDetailsWarn: 'Please select at least one insurance.',
    FeedbackSubmitSuccess: 'Feedback submitted successfully.',
    SubmitFeedbackWarn: 'Do you want to submit this feedback?',
    InvalidProfileLink: 'Profile completion link is invalid.',
    PaymentCaptureSuccess: 'Payment captured successfully.',
    PaymentError: 'Your payment has been cancelled. Please try again.',
    RecordAddSuccess: 'Medical record saved successfully.',
    RecordDeleteSuccess: 'Medical record deleted successfully.',
    DeleteRecordContent: 'Do you want to delete this medical record?',
    UpgradeHealthCarePlanSuccess: 'Healthcare plan upgraded successfully.',
    CancelHealthPlanSubscriptionWarn: 'Do you want to cancel this active care plan?',
    DeleteSavedCardWarn: 'Do you want to delete this saved card?',
    DeleteSavedCardSuccess: 'Card deleted successfully.',
    DeleteCardValidationError: `Cannot be deleted because it is associated with an active healthcare plan subscription.`,
    RenewHealthCarePlanSuccess: 'Healthcare plan renewed successfully.',
    PatientFormSubmitSuccess: 'Patient form submitted successfully.',
    PasswordChangeError: 'Your password has expired. You need to change your password before you proceed.',
    CancelSubscription: 'Do you want to cancel this subscription?',
    SubscriptionCancelledSuccess: 'Subscription cancelled successfully.',
    VisitSummaryPrint: 'Visit summary is printed for patient.',
};
